/// <reference path="references.ts" />
var ApfcoRootUrl; //This should be defined in the HTML layout
var Apfco;
(function (Apfco) {
    Apfco.rootUrl = ApfcoRootUrl; //Pull this into the namespace variable so it's strongly typed
})(Apfco || (Apfco = {}));
//# sourceMappingURL=Apfco.js.map